import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue";
import { ref, onMounted, watch } from 'vue';
import { generateRoutes } from './FuseData.js';
import Fuse from 'fuse.js';
import { filterRouters } from '@/utils/route.js';
import { useRouter } from 'vue-router';
import { watchSwitchLang } from '@/utils/i18n.js';

// ------------- 1. 基础变量定义（按使用顺序）-------------
// 搜索结果

export default {
  __name: 'index',
  setup(__props) {
    const searchOptions = ref([]);
    // 搜索关键词
    const search = ref('');
    // 控制 search 显示
    const isShow = ref(false);
    // el-select 实例
    const headerSearchSelectRef = ref(null);
    const router = useRouter();

    // ------------- 2. 搜索数据源-------------
    const searchPool = ref([]);

    // ------------- 3. 加载数据源方法-------------
    const loadSearchPool = () => {
      try {
        // 调用 filterRouters 过滤路由，加兜底为空数组
        const filteredRoutes = filterRouters(router.getRoutes()) || [];
        // 生成搜索数据源，赋值给 ref 类型的 searchPool
        searchPool.value = generateRoutes(filteredRoutes) || [];
      } catch (e) {
        console.error('加载搜索数据源失败：', e);
        searchPool.value = [];
      }
    };

    // ------------- 4. Fuse 初始化逻辑 -------------
    // 搜索库实例
    let fuse = null;
    // 初始化Fuse（加兜底）
    const initFuse = data => {
      // 兜底：确保数据源是数组，非数组则置空
      const validData = Array.isArray(data) ? data : [];
      // 销毁旧实例（避免内存泄漏）
      fuse = null;
      // 只有数据源非空时才初始化Fuse
      if (validData.length) {
        fuse = new Fuse(validData, {
          shouldSort: true,
          minMatchCharLength: 1,
          keys: [{
            name: 'title',
            weight: 0.7
          }, {
            name: 'path',
            weight: 0.3
          }]
        });
      }
    };

    // ------------- 5. 核心方法定义 -------------
    // 新增：搜索框显示/隐藏方法（模板调用）
    const onShowClick = () => {
      isShow.value = !isShow.value;
      // 打开时清空搜索状态
      if (isShow.value) {
        search.value = '';
        searchOptions.value = [];
      }
    };

    // 搜索方法（加多层兜底）
    const querySearch = (query = '') => {
      const validQuery = String(query).trim();
      // 兜底：Fuse实例不存在/无数据源/无关键词 → 返回空数组
      if (!fuse || !searchPool.value.length || !validQuery) {
        searchOptions.value = [];
        return;
      }
      // 执行搜索（加try/catch防止内部报错）
      try {
        searchOptions.value = fuse.search(validQuery) || [];
      } catch (e) {
        console.error('搜索出错：', e);
        searchOptions.value = [];
      }
    };

    // 选中回调（加兜底）
    const onSelectChange = option => {
      if (option?.path) {
        router.push(option.path);
        // 选中后关闭搜索框
        onClose();
      }
    };

    // 关闭 search（加兜底）
    const onClose = () => {
      headerSearchSelectRef.value?.blur();
      isShow.value = false;
      searchOptions.value = [];
      search.value = ''; // 清空关键词
    };

    // ------------- 6. 生命周期 + 监听 -------------
    // 组件挂载后初始化
    onMounted(() => {
      loadSearchPool(); // 加载数据源
      initFuse(searchPool.value); // 初始化Fuse
    });

    // 修复：提取 handleClick 到外部，避免内存泄漏
    const handleClick = e => {
      // 排除点击搜索图标/下拉框本身
      if (!e.target.closest('.header-search')) {
        onClose();
      }
    };
    // 监听搜索框显示状态，绑定/解绑点击事件
    watch(isShow, val => {
      if (val) {
        document.body.addEventListener('click', handleClick);
      } else {
        document.body.removeEventListener('click', handleClick);
      }
    }, {
      immediate: false
    });

    // 语言切换后重新加载数据源 + 初始化Fuse
    watchSwitchLang(() => {
      loadSearchPool();
      initFuse(searchPool.value);
    });

    // 监听数据源变化，自动更新Fuse（可选，确保数据源变了搜索规则也更新）
    watch(searchPool, newVal => {
      initFuse(newVal);
    }, {
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([{
          show: isShow.value
        }, "header-search"])
      }, [_createVNode(_component_svg_icon, {
        id: "guide-search",
        "class-name": "search-icon",
        icon: "search",
        onClick: _withModifiers(onShowClick, ["stop"])
      }), _createVNode(_component_el_select, {
        ref_key: "headerSearchSelectRef",
        ref: headerSearchSelectRef,
        class: "header-search-select",
        modelValue: search.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.value = $event),
        filterable: "",
        "default-first-option": "",
        remote: "",
        placeholder: "Search",
        "remote-method": querySearch,
        onChange: onSelectChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchOptions.value, option => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: option.item?.path || `search-${Date.now()}-${Math.random()}`,
            label: Array.isArray(option.item?.title) ? option.item.title.join(' > ') : option.item?.title,
            value: option.item
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])], 2);
    };
  }
};